import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { BetSlipContext } from '@/components/betSlip/betSlipContext';
import { BetSlipType } from '@/interface/IBetSlip';
import { SiteStyle } from '@/interface/enum';
import { useBetSlipStore } from '@/store/betSlipStore';
import { useToggleStore } from '@/store/toggleStore';

export default function useJackpotMessage() {
    const {
        eFootballZoneLeagueIds,
        isJackpotEnabled,
        isSwitchEFootballToSimulationSportsZoneEnabled,
        simulationSportsZoneLeagueIds,
    } = storeToRefs(useToggleStore(SiteStyle.Asia));
    const { betSlip, voucherEnabled } = BetSlipContext.inject();
    const balance = computed(() => betSlip.value.balance);

    const { singleBetSlip } = storeToRefs(useBetSlipStore());
    const betSlipLeagueIds = computed(() => singleBetSlip.value?.tickets.map(ticket => ticket.event.league.id));

    const supportedLeagueIds = computed(() => {
        if (isSwitchEFootballToSimulationSportsZoneEnabled.value) {
            return Object.values(simulationSportsZoneLeagueIds.value).flat();
        }
        return eFootballZoneLeagueIds.value;
    });

    const isShowJackpotMessage = computed(() => isJackpotEnabled.value && betSlip.value.type === BetSlipType.Single
        && balance.value !== null
        && supportedLeagueIds.value.some(x => betSlipLeagueIds.value?.includes(x))
        && !voucherEnabled.value);

    return {
        isShowJackpotMessage,
    };
}
